module.exports = __webpack_public_path__ + "static/media/plate.8ce7a634.svg";